var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton"},[_c('div',{staticClass:"square",class:_vm.classesSquare,style:([{height: `${_vm.height}px`}, {width: `${_vm.width}${_vm.percentage? '%' : 'px'}`}, {borderRadius: `${_vm.borderRadius}px`}])})])
}
var staticRenderFns = []

export { render, staticRenderFns }